import type { Locale } from './api/types'

const LOCALE_MAP: Record<Locale, string> = { it: 'it-IT', en: 'en-GB', de: 'de-DE', fr: 'fr-FR', hr: 'hr-HR', sl: 'sl-SI', zh: 'zh-CN' }

/** Format integer cents as a EUR currency string for the given locale. */
export function formatCents(cents: number | null | undefined, locale: Locale = 'it'): string {
  const value = (cents ?? 0) / 100
  return new Intl.NumberFormat(LOCALE_MAP[locale] ?? 'it-IT', {
    style: 'currency',
    currency: 'EUR',
  }).format(value)
}

export function eur(cents: number | null | undefined): number {
  return (cents ?? 0) / 100
}
